var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"homebutton"},[_c('SprButton',{staticClass:"home",attrs:{"size":4,"primary":true,"title":_vm.$t('customerForm.homeButton'),"preicon":"home","click-event":"home"},on:{"home":_vm.onHomeClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }